import { useStytchMemberSession } from "@stytch/react/b2b";
import { Navigate } from "react-router-dom";
import { DEFAULT_LANDING_PATH } from "../../utils/routes";

const Fallback = () => {
  const { session } = useStytchMemberSession();

  if (session) {
    return <Navigate to={DEFAULT_LANDING_PATH} />;
  }

  return <Navigate to="/signup" />;
};

export default Fallback;
